export const guestHeight = [
	{ id: 100, text: '100 cm' },
	{ id: 120, text: '120 cm' },
	{ id: 130, text: '130 cm' },
	{ id: 140, text: '140 cm' }
]

export const guestWeight = [
	{ id: 50, text: '50 kg' },
	{ id: 60, text: '60 kg' },
	{ id: 70, text: '70 kg' },
	{ id: 80, text: '80 kg' }
]

export const guestShoeSize = [
	{ id: 38, text: '38' },
	{ id: 40, text: '40' },
	{ id: 42, text: '42' },
	{ id: 44, text: '44' }
]

export const guestHeadSize = [
	{ id: 10, text: '10 cm' },
	{ id: 20, text: '20 cm' },
	{ id: 30, text: '30 cm' },
	{ id: 40, text: '40 cm' }
]

export const stripHtml = function (value) {
	var tmp = document.createElement('DIV')
	tmp.innerHTML = value
	var res = tmp.textContent || tmp.innerText || ''
	res.replace('\u200B', '') // zero width space
	res = res.trim()

	return res
}

export const addToTotal = function(currentTotal, amountToAdd) {
    if (typeof amountToAdd === 'string') {
        // Check if amountToAdd is a string
        const parsedAmount = parseFloat(amountToAdd);
        if (!isNaN(parsedAmount)) {
            // Check if the parsed amount is a valid number
            return currentTotal + parsedAmount;
        } else {
            // Handle the case where parsing fails
            return currentTotal; // Return the current total without adding
        }
    } else if (typeof amountToAdd === 'number') {
        // If it's already a number, just add it
        return currentTotal + amountToAdd;
    } else {
        // Handle other data types
        return currentTotal + amountToAdd; // Return the current total without adding
    }
}